import { render, staticRenderFns } from "./NewMessageNotification.vue?vue&type=template&id=f346da24&"
import script from "./NewMessageNotification.vue?vue&type=script&lang=js&"
export * from "./NewMessageNotification.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports